<template>
          <v-card
          class="pa-5"
          outlined
          tile
        >
         <v-text-field 
          v-model='currentPatient.info.recordNum'
            label="Patient Record #"
          ></v-text-field>
         <v-text-field 
          v-model='currentPatient.info.name'
            label="Patient Name"
          ></v-text-field>
         <v-text-field 
          v-model='currentPatient.info.email'
            label="Patient Email"
          ></v-text-field>
        <v-text-field 
          v-model='currentPatient.info.phone'
            label="Patient Phone #"
          ></v-text-field>
          <v-text-field 
          v-model='currentPatient.createDateinUtc'
            label="Account create date"
          ></v-text-field>
          <v-text-field 
          v-model='formattedAddress'
            label="Patient Address"
          ></v-text-field>
         
         
        </v-card>
</template>

<script>
export default {
  props : {
        currentPatient : Object
    },
  computed : {
    formattedAddress(){
      var address = this.currentPatient.info.address
      //add backward comptiability
      if(typeof address === 'string'){
        return address
      }
      let formattedInput = address.street + " " + address.city + " " + address.state + " " + address.zip;

      return formattedInput;



    }
  }
}
</script>

<style>

</style>